import { render, staticRenderFns } from "./businesshours.vue?vue&type=template&id=60180e20&scoped=true&lang=pug&"
import script from "./businesshours.vue?vue&type=script&lang=js&"
export * from "./businesshours.vue?vue&type=script&lang=js&"
import style0 from "./businesshours.vue?vue&type=style&index=0&id=60180e20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60180e20",
  null
  
)

export default component.exports